<template>
    <div>
        <PageHeader>
            {{ $t('widgeterReportsPages.title') }}
            <template #side>
                <div class="d-flex gap-3">
                    <MultiselectSpaces
                        v-model="pages"
                        class="width-500"
                        :disabled="isSpaceReportLoading"
                        @loading="value => isSpacesLoading = value"
                    />
                    <TimeRangeCalendar v-model="timeRange" :disabled="loading" />
                </div>
            </template>
        </PageHeader>

        <div class="d-flex flex-column gap-3">

            <div class="d-flex gap-3 flex-wrap">
                <MultiEChartCard class="flex-basis-0 flex-grow-2" :data="lineChartData" :height="400" :loading="loading" @currentChart="setCurrentChart" />
                <EChart card :height="400" :options="pieChartData[currentChart]" :loading="loading" class="flex-basis-0 flex-grow-1 m-0 p-0" />
            </div>

            <SiteStatistics :space-ids="spaceIds || []" :time-range="timeRange || {}" />

        </div>
    </div>
</template>



<script>
    import ReportsPages from '@/views/common/reports/pages/index.vue';

    export default {
        name: 'AdvertiserReportsPages',
        mixins: [ReportsPages],
        computed: {
            campaignId() {
                return this.$store.getters['campaigns/getCurrentCampaign']?.id;
            },
            requestParams() {
                return {
                    ...ReportsPages.computed.requestParams.bind(this)(),
                    showFirst: 5,
                };
            },
        },
        watch: {
            timeRange() {
                this.clearChartData();
                this.fetchSpaceReport();
            },
            campaignId() {
                this.pages = [];
            },
        },
    };
</script>
